import "./Tuyendung.css";
export default function Topbar() {
  return (
    <div className="topbar">
      <div className="wrap topbar-inner">
        <div className="topbar-msg">
          <span className="dot-live" />
          <strong>Đang tuyển gấp</strong> — Nhận việc làm ngay trong tuần
        </div>
        <a className="topbar-call" href="tel:0364481934">
          📞 Hotline: 0364 481 934
        </a>
      </div>
    </div>
  );
}